// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__1ZR3f","children":"Checkbox_children__1C4sw","error":"Checkbox_error__HK6oE"};